import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import Listar from '../../../../components/auth/ouvidoria/pesquisa'


function ListarPesquisasScreen() {

    return (
        <Fragment>
            <Head titulo="Pesquisa de Satisfação" />
            <HeaderLogged />
            <Container>
               <Listar />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListarPesquisasScreen;